import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getPAGAA000, postPAGAI010Document } from '../../../services/Api';
import ImageCheckFallback from '../../../shared/components/ImageCheckFallback';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { getImageSrc, updateMenuVisibility } from '../../../utils';

const PAGAI010 = () => {
    const [listEvent, setListEvent] = useState({});
    const [searchParams, setSearchParam] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [isEnd, setIsEnd] = useState(['001', '002', '003', '004', '005', '006']);
    // const [keyword, setKeyword] = useState('');
    const [popup, setPopup] = useState(false);
    const [prevImg, setPrevImg] = useState('');
    const [gubun, setGubun] = useState('');
    const [title, setTitle] = useState('');

    const handleIcon = (fileType) => {
        if (fileType === 'doc' || fileType === 'docx') {
            return 'word';
        } else if (fileType === 'xls' || fileType === 'xlsx' || fileType === 'csv') {
            return 'excel';
        } else if (fileType === 'zip' || fileType === 'rar') {
            return 'zipSmall';
        } else if (fileType === 'pdf') {
            return 'pdf';
        } else if (fileType === 'hwp') {
            return 'hwp';
        } else if (fileType === 'ppt' || fileType === 'pptx') {
            return 'ppt';
        } else if (fileType === 'txt') {
            return 'txt';
        } else if (fileType === 'jpg') {
            return 'jpg';
        } else if (fileType === 'png') {
            return 'png';
        } else {
            return 'file';
        }
    };

    const [filter, setFilter] = useState([
        { label: '전체', countKey: 'countTab01', value: ['001', '002', '003', '004', '005', '006'], active: 1 },
        { label: '이력서 관련 서식', countKey: 'countTab02', value: ['001'], active: 0 },
        { label: '인사노무서식', countKey: 'countTab03', value: ['002'], active: 0 },
        { label: '기타', countKey: 'countTab04', value: ['003', '004', '005', '006'], active: 0 },
    ]);

    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    const handlePopup = (prevImg, gubun, title) => {
        setPopup(!popup);
        setPrevImg(prevImg);
        setGubun(gubun);
        setTitle(title);
    };

    const handleClosePopup = () => {
        setPopup(!popup);
        setPrevImg('');
        setGubun('');
        setTitle('');
    };

    // const inputChange = (e) => {
    //     setKeyword(e.target.value);
    // };

    // const handleKeyDown = (e) => {
    //     if (e.key === 'Enter') {
    //         getListData();
    //         setSearchParam(1);
    //     }
    // };

    // const handleSearchIconClick = () => {
    //     getListData();
    //     setSearchParam(1);
    // };

    const handleCountTab = (count) => {
        let filteredOptions = ['001', '002', '003', '004', '005', '006'];
        switch (count) {
            case 'countTab01':
                filteredOptions = ['001', '002', '003', '004', '005', '006'];
                break;
            case 'countTab02':
                filteredOptions = ['001'];
                break;
            case 'countTab03':
                filteredOptions = ['002'];
                break;
            case 'countTab04':
                filteredOptions = ['003', '004', '005', '006'];
                break;
            default:
                filteredOptions = [];
        }
        setIsEnd(filteredOptions);
    };

    const handleChangeIsEnd = (e) => {
        const dataIsEnd = e.target.dataset.value;
        handleCountTab(dataIsEnd);

        setFilter((prevFilters) =>
            prevFilters.map((item) => ({
                ...item,
                active: item.countKey === dataIsEnd ? 1 : 0,
            })),
        );
        setSearchParam(1);
    };

    const getListData = () => {
        postPAGAI010Document({
            page,
            size: 12,
            options: { gubun: isEnd },
            // keyword: keyword
        })
            .then(({ data }) => {
                setListEvent(data.data);
                setPages(data.info);
            })
            .catch((error) => console.error('Error fetching data:', error));
    };

    useEffect(() => {
        getListData();
        //eslint-disable-next-line
    }, [page, isEnd]);

    return (
        <>
            <div id="content">
                <Nav menu={dentalPlusMenu} />
                <div id="tableVolunteer">
                    <h3 className="vln__tit">문서서식</h3>
                    <div className="header-table">
                        <div className="header-left">
                            {filter.map((item, index) => (
                                <div
                                    key={`item-${index}`}
                                    className={`item-header ${item.active ? 'active' : ''}`}
                                    data-value={item.countKey}
                                    onClick={handleChangeIsEnd}
                                    value={item.value}
                                >
                                    {item.label} (<span>{listEvent?.statistic?.[0]?.[item.countKey] || 0}</span>)
                                </div>
                            ))}
                        </div>
                        {/* <div className="header-right gray">
                            <input
                                type="text"
                                placeholder="검색어 입력"
                                onChange={inputChange}
                                onKeyDown={handleKeyDown}
                            />
                            <i className="icon icon-magnifying-glass-line" onClick={handleSearchIconClick}></i>
                        </div> */}
                    </div>
                    <div className="vln-dcm">
                        <ul className="vln-dcm__list" style={{ display: listEvent.list === null ? 'flex' : '' }}>
                            {listEvent.list && listEvent.list.length > 0 ? (
                                listEvent.list.map((item, index) => {
                                    return (
                                        <React.Fragment key={item.seq}>
                                            <li key={`${item.seq}-${index}`} className="vln-dcm__item">
                                                <span>{item.gubun}</span>
                                                <button
                                                    type="button"
                                                    className="vln-dcm__pop"
                                                    id={`formTmpl-${index}`}
                                                    data-type="popup"
                                                    onClick={() => handlePopup(item?.prevImg, item?.gubun, item?.title)}
                                                >
                                                    {item.title}
                                                </button>
                                                <div className="vln-dcm__down">
                                                    <a
                                                        href={`${getImageSrc('biz_forms', item?.attachFile)}`}
                                                        className="vln-dcm__down-btn"
                                                        download={item?.attachFile}
                                                    >
                                                        <img
                                                            src={`./images/icons/icon-${handleIcon(item.fileType)}.png`}
                                                            alt={item.prevImg}
                                                        />
                                                        <span>다운로드</span>
                                                    </a>
                                                </div>
                                            </li>
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <div className="no-data">데이터없습니다</div>
                            )}
                        </ul>
                    </div>
                    <Pagination pages={pages} />
                </div>
            </div>
            {popup && (
                <div id="footer">
                    <div className="popup active">
                        <div className="vln-popup">
                            <h3 className="vln-popup__tit">
                                {gubun} - {title}
                            </h3>
                            <button className="popup-close sizeUp" type="button" onClick={handleClosePopup} />
                            <div className="vln-popup__cnt">
                                <ImageCheckFallback folderName="biz_forms" imgName={prevImg} alt="preview" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PAGAI010;
